import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useState } from 'react';
import { useReceipts } from '@/account/payments/useReceipts';
import { Stack, Table } from '@/theme/index';
import {
  OrderHistoryAccordion,
  renderOrderHistoryTableContent,
  renderOrderHistoryTableHeader,
} from './components';
import { Receipt } from '../..';
import { MergedReceiptComponent } from '../PDF/MergedReceipts/MergedReceipts';

/**
 * This component is used to display the user's order history which includes the date, transaction,
 * payment method used, and amount.
 */
export const ViewOrderHistory = () => {
  const { data, isError } = useReceipts();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [chosenReceipts, setChosenReceipts] = useState<number[]>([]);

  const addChosenReceipt = (index: number) => {
    setChosenReceipts([...chosenReceipts, index]);
  };

  const removeAllChosenReceipts = () => {
    setChosenReceipts([]);
  };

  const addAllChosenReceipts = () => {
    setChosenReceipts(
      data?.receipts?.map((receipt: Receipt, index: number) => index) || []
    );
  };

  const chooseAReceipt = (index: number) => {
    if (chosenReceipts.includes(index)) {
      setChosenReceipts(
        chosenReceipts.filter((receiptIntex) => receiptIntex !== index)
      );
    } else {
      addChosenReceipt(index);
    }
  };

  const filterReceiptsBasedOnChosen = (receipts: Receipt[]) => {
    return receipts?.filter((receipt: Receipt, index: number) =>
      chosenReceipts.includes(index)
    );
  };
  return (
    <OrderHistoryAccordion display="View order history" data-cy="order_history">
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        {!isMobile && (
          <MergedReceiptComponent
            receipts={filterReceiptsBasedOnChosen(data?.receipts)}
          />
        )}
        <MergedReceiptComponent receipts={data?.receipts} downloadAll />
      </Stack>
      <Table
        data-cy="order_history_data"
        headerRowStyle={{ padding: '8px' }}
        headers={
          data?.receipts?.length === 0 || data === undefined || isError
            ? ['No payment history found']
            : renderOrderHistoryTableHeader(
                isMobile,
                chosenReceipts.length > 0,
                addAllChosenReceipts,
                removeAllChosenReceipts
              )
        }
        rows={renderOrderHistoryTableContent({
          receipts: data?.receipts,
          isMobile,
          chosenReceipts,
          chooseAReceipt,
        })}
        bodyRowStyle={{
          borderBottom: isMobile ? '1px solid rgba(224, 224, 224, 1)' : '',
        }}
      />
    </OrderHistoryAccordion>
  );
};
